import { render, staticRenderFns } from "./side-drawer.vue?vue&type=template&id=bd5c04a8"
import script from "./side-drawer.vue?vue&type=script&lang=js"
export * from "./side-drawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd5c04a8')) {
      api.createRecord('bd5c04a8', component.options)
    } else {
      api.reload('bd5c04a8', component.options)
    }
    module.hot.accept("./side-drawer.vue?vue&type=template&id=bd5c04a8", function () {
      api.rerender('bd5c04a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/side-drawer.vue"
export default component.exports